import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { FlowPathBadge } from './FlowPathBadge';
import { useSettings } from '../../context/SettingsContext';

type FlowEntryBannerProps = {
    title: string;
    pathLabel: string;
    nextHint: string;
    helpModule?: string;
};

export const FlowEntryBanner: React.FC<FlowEntryBannerProps> = ({
    title,
    pathLabel,
    nextHint,
    helpModule = 'sales_crm',
}) => {
    const { getSetting } = useSettings();
    const flowCoachEnabled = String(getSetting('ui_flow_coach_enabled') || 'true').toLowerCase() !== 'false';
    if (!flowCoachEnabled) return null;
    return (
        <Card className="border-blue-100 bg-blue-50/50">
            <CardContent className="flex flex-wrap items-center justify-between gap-3 p-3">
                <div>
                    <p className="text-sm font-semibold text-slate-900">{title}</p>
                    <p className="text-xs text-slate-600">{nextHint}</p>
                </div>
                <div className="flex items-center gap-2">
                    <FlowPathBadge label={pathLabel} />
                    <Link to={`/help?module=${helpModule}`} className="text-xs font-medium text-blue-700 hover:underline">
                        Open Playbook
                    </Link>
                </div>
            </CardContent>
        </Card>
    );
};
